import { api, queryKeys } from './client';
import type { BootstrapResponse } from '../types/api.types';

/**
 * Fetch bootstrap configuration for tenant
 * This includes tenant info, theme, and module registry
 */
export async function fetchBootstrapConfig(tenantId: string | null): Promise<BootstrapResponse> {
  const subDomain = tenantId || '';

  const response = await api.post<BootstrapResponse>('/v1/tenant/bootstrap', { subDomain });

  return response.data;
}

/**
 * Query keys for bootstrap
 */
export const bootstrapKeys = {
  config: (tenantId: string | null) => queryKeys.bootstrap(tenantId),
};
